import Vue from 'vue'
import Router from 'vue-router'

// 导入对应的vuex文件
import store from './../store/store'

// 导入相应的子组件
import status from './../components/view/status/index'
import test from './../components/view/test/index'
import testviser from './../components/view/testviser/index'
import mainpage from './../components/view/mainpage/index'
import login from './../components/view/login/index'
import twiceconfirm from './../components/view/twiceconfirm/index'
import forgotpassword from './../components/view/forgotpassword/index'
import repassword from './../components/view/repassword/index'
import sitesetting from './../components/view/sitesetting/index'

import error403 from './../components/view/403/index'
import error404 from './../components/view/404/index'
import error500 from './../components/view/500/index'

import membermanagement from './../components/view/membermanagement/index'
import creditmanagement from './../components/view/membermanagement/creditmanagement/index'


import transactionlist from './../components/view/ordermanagement/transactionlist/index'
import transactionreconciliation from './../components/view/ordermanagement/transactionreconciliation/index'
import notetemplate from './../components/view/ordermanagement/notetemplate/index'

import agentlist from './../components/view/agentmanagement/agentlist/index'
import agentinfo from './../components/view/agentmanagement/agentinfo/index'

import servicelist from './../components/view/pricepage/servicelist/index'
import servicedetails from './../components/view/pricepage/servicedetails/index'
import saleslist from './../components/view/pricepage/saleslist/index'
import salesdetails from './../components/view/pricepage/salesdetails/index'

import administratormanagement from './../components/view/usermanagement/administratormanagement/index'
import permissionmanagement from './../components/view/usermanagement/permissionmanagement/index'
import newadministrator from './../components/view/usermanagement/newadministrator/index'

import accountpandect from './../components/view/voucher/accountpandect/index'
import voucher from './../components/view/voucher/voucher/index'
import vouchersuccess from './../components/view/voucher/vouchersuccess/index'

import bdmanagement from './../components/view/bdmanagement/index'
import bdinfo from './../components/view/bdmanagement/bdinfo/index'
import bdtrade from './../components/view/bdmanagement/bdtrade/index'
import bdtradeinfo from './../components/view/bdmanagement/bdtradeinfo/index'

import bdreconciliation from './../components/view/bdreconciliation/index'
import reconciliation_trade from './../components/view/bdreconciliation/reconciliation_trade/index'
import reconciliationresult from './../components/view/bdreconciliation/reconciliationresult/index'

import salemainpage from './../components/view/sale/salemainpage/index'
import skumanagement from './../components/view/sale/skumanagement/index'
import terminalmanagement from './../components/view/sale/terminalmanagement/index'

Vue.use(Router)

var router = new Router({
	mode: 'history',
	routes: [{
			path: '*',
			redirect: '/mainpage'
		},
		{
			path: '/status',
			name: 'status',
			component: status
		},
		{
			path: '/sitesetting',
			name: 'sitesetting',
			component: sitesetting
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '/twiceconfirm',
			name: 'twiceconfirm',
			component: twiceconfirm
		},
		{
			path: '/forgotpassword',
			name: 'forgotpassword',
			component: forgotpassword
		},
		{
			path: '/repassword',
			name: 'repassword',
			component: repassword
		},
		{
			path: '/test',
			name: 'test',
			component: test
		},
		{
			path: '/testviser',
			name: 'testviser',
			component: testviser
		},
		{
			path: '/mainpage',
			name: 'mainpage',
			component: mainpage,
			// component: resolve => require(['./../components/view/mainpage/index'],resolve)
			// component: r => require.ensure([], () => r(require('./../components/view/mainpage/index')), 'demo')
		},
		{
			path: '/transactionlist',
			name: 'transactionlist',
			component: transactionlist,
			// component: resolve => require(['./../components/view/ordermanagement/transactionlist/index'], resolve)
			// component: r => require.ensure([], () => r(require('./../components/view/ordermanagement/transactionlist/index')), 'demo2')
		},
		{
			path: '/transactionreconciliation',
			name: 'transactionreconciliation',
			component: transactionreconciliation,
		},
		{
			path: '/notetemplate',
			name: 'notetemplate',
			component: notetemplate,
		},
		{
			path: '/servicelist',
			name: 'servicelist',
			component: servicelist,
		},
		{
			path: '/servicedetails',
			name: 'servicedetails',
			component: servicedetails,
		},
		{
			path: '/saleslist',
			name: 'saleslist',
			component: saleslist,
		},
		{
			path: '/salesdetails',
			name: 'salesdetails',
			component: salesdetails,
		},
		{
			path: '/membermanagement',
			name: 'membermanagement',
			component: membermanagement,
		},
		{
			path: '/creditmanagement',
			name: 'creditmanagement',
			component: creditmanagement,
		},
		{
			path: '/agentlist',
			name: 'agentlist',
			component: agentlist,
		},
		{
			path: '/agentinfo',
			name: 'agentinfo',
			component: agentinfo,
		},
		{
			path: '/administratormanagement',
			name: 'administratormanagement',
			component: administratormanagement,
		},
		{
			path: '/permissionmanagement',
			name: 'permissionmanagement',
			component: permissionmanagement,
		},
		{
			path: '/newadministrator',
			name: 'newadministrator',
			component: newadministrator,
		},
		{
			path: '/accountpandect',
			name: 'accountpandect',
			component: accountpandect,
		},
		{
			path: '/voucher',
			name: 'voucher',
			component: voucher,
		},
		{
			path: '/vouchersuccess',
			name: 'vouchersuccess',
			component: vouchersuccess,
		},
		{
			path: '/bdmanagement',
			name: 'bdmanagement',
			component: bdmanagement,
		},
		{
			path: '/bdinfo',
			name: 'bdinfo',
			component: bdinfo,
		},
		{
			path: '/bdtrade',
			name: 'bdtrade',
			component: bdtrade,
		},
		{
			path: '/bdtradeinfo',
			name: 'bdtradeinfo',
			component: bdtradeinfo,
		},
		{
			path: '/bdreconciliation',
			name: 'bdreconciliation',
			component: bdreconciliation,
		},
		{
			path: '/reconciliation_trade',
			name: 'reconciliation_trade',
			component: reconciliation_trade,
		},
		{
			path: '/reconciliationresult',
			name: 'reconciliationresult',
			component: reconciliationresult,
		},
		{
			path: '/salemainpage',
			name: 'salemainpage',
			component: salemainpage,
		},
		{
			path: '/skumanagement',
			name: 'skumanagement',
			component: skumanagement,
		},
		{
			path: '/terminalmanagement',
			name: 'terminalmanagement',
			component: terminalmanagement,
		},
		{
			path: '/error403',
			name: 'error403',
			component: error403,
		},
		{
			path: '/error404',
			name: 'error404',
			component: error404,
		},
		{
			path: '/error500',
			name: 'error500',
			component: error500,
		},
	]
})


export default router



// WEBPACK FOOTER //
// ./src/client/router/index.js